import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Work from "@/components/site/Work";
import EstimateCTA from "@/components/site/EstimateCTA";
import ServiceArea from "@/components/site/ServiceArea";
import Testimonials from "@/components/site/Testimonials";
import ContactForm from "@/components/site/ContactForm";
import Footer, { MobileCTABar } from "@/components/site/Footer";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Work />
        <EstimateCTA />
        <ServiceArea />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
}
